/**
 * All fulfillment options
 *
 * @type {{PICKUP: string, DINE_IN: string, DELIVERY: string}}
 */
export const fulfillmentOptions = {
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
  DINE_IN: 'dine_in'
};

/**
 * Online ordering fulfillment methods that does not require
 * a seating arrangement for the customer.
 *
 * @type {(string)[]}
 */
export const ALL_ONLINE_ORDERING_FULFILLMENT_METHODS = [
  fulfillmentOptions.DELIVERY,
  fulfillmentOptions.PICKUP
];

/**
 * All fulfillment methods
 *
 * @type {(string)[]}
 */
export const ALL_FULFILLMENT_METHODS = Object.values(fulfillmentOptions);
